import React from "react";

const SvgIcon = ({ src, width = 24, height = 24, alt = 'icon' }) => {
    return (
        <div style={{
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            padding: '0.5rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${width + 4}px`,
            height: `${height + 4}px`,
            }}
        >
        <img
            src={src}
            width={width}
            height={height}
            alt={alt}
            style={{
                display: 'block',
            }}
        />
    </div>
    );
  };

  export default SvgIcon;